import { QueryDispatcher } from 'SourceUtil/Request';
import { showNotification } from 'SourceStore/Notification/Notification.action';
import { ONE_MONTH_IN_SECONDS } from 'SourceUtil/Request/QueryDispatcher';
import { TikTokLoginQuery } from '../../query';
import { executePost, fetchMutation, getErrorMessage } from 'SourceUtil/Request';

/**
 * TikTokFeed Dispatcher
 * @extends QueryDispatcher
 * @namespace MageGuide/TikTokFeed/Store/TikTokLoginD/Dispatcher
 */
export class TikTokLoginDispatcher {

    prepareTikTokLogin(options = {}, dispatch) {
        const mutation = TikTokLoginQuery.getTikTokLoginMutation(options);

        return fetchMutation(mutation).then(
            /** @namespace MageGuide/TikTokFeed/Dispatcher/prepareTikTokLoginFetchMutationThen */
            ({ token }) => console.log(token),
            /** @namespace MageGuide/TikTokFeed/Dispatcher/prepareTikTokLoginFetchMutationError */
            (error) => dispatch(showNotification('error', getErrorMessage(error)))
        );
    }

}

export default new (TikTokLoginDispatcher)();
